/* ═════ Live Intelligence dropdown option lists ═════
   Values mirror the JamBase gateway params (genreSlug, geoCountryIso2,
   geoStateIso, geoMetroId, eventDatePreset). Each option is [value, label]. */

export const GENRES = [
  ["", "Any genre"],
  ["bluegrass", "Bluegrass"],
  ["blues", "Blues"],
  ["christian", "Christian"],
  ["classical", "Classical"],
  ["country-music", "Country Music"],
  ["edm", "EDM"],
  ["folk", "Folk"],
  ["hip-hop-rap", "Hip-Hop / Rap"],
  ["indie", "Indie"],
  ["jamband", "Jam Band"],
  ["jazz", "Jazz"],
  ["kpop", "K-pop"],
  ["latin", "Latin"],
  ["metal", "Metal"],
  ["pop", "Pop"],
  ["punk", "Punk"],
  ["reggae", "Reggae"],
  ["rhythm-and-blues-soul", "R&B / Soul"],
  ["rock", "Rock"],
  ["tribute", "Tribute"],
];

export const EVENT_TYPES = [
  ["", "All types"],
  ["concerts", "Concerts"],
  ["festivals", "Festivals"],
];

export const DATE_PRESETS = [
  ["", "Any date"],
  ["today", "Today"],
  ["tomorrow", "Tomorrow"],
  ["thisWeekend", "This weekend"],
  ["nextWeekend", "Next weekend"],
  ["halloween", "Halloween"],
  ["newYears", "New Year's Eve"],
  ["july4th", "July 4th"],
];

export const PER_PAGE_OPTS = [20, 40, 60, 100];

export const ARTIST_UPCOMING = [
  ["", "All artists"],
  ["true", "Has upcoming events"],
];

export const COUNTRIES = [
  ["AF", "Afghanistan"],
  ["AL", "Albania"],
  ["DZ", "Algeria"],
  ["AS", "American Samoa"],
  ["AD", "Andorra"],
  ["AO", "Angola"],
  ["AI", "Anguilla"],
  ["AG", "Antigua And Barbuda"],
  ["AR", "Argentina"],
  ["AM", "Armenia"],
  ["AW", "Aruba"],
  ["AU", "Australia"],
  ["AT", "Austria"],
  ["AZ", "Azerbaijan"],
  ["BS", "Bahamas, The"],
  ["BH", "Bahrain"],
  ["BD", "Bangladesh"],
  ["BB", "Barbados"],
  ["BY", "Belarus"],
  ["BE", "Belgium"],
  ["BZ", "Belize"],
  ["BJ", "Benin"],
  ["BM", "Bermuda"],
  ["BT", "Bhutan"],
  ["BO", "Bolivia"],
  ["BA", "Bosnia And Herzegovina"],
  ["BW", "Botswana"],
  ["BR", "Brazil"],
  ["IO", "British Indian Ocean Territory"],
  ["BN", "Brunei"],
  ["BG", "Bulgaria"],
  ["BF", "Burkina Faso"],
  ["BI", "Burundi"],
  ["CV", "Cabo Verde"],
  ["KH", "Cambodia"],
  ["CM", "Cameroon"],
  ["CA", "Canada"],
  ["KY", "Cayman Islands"],
  ["CF", "Central African Republic"],
  ["TD", "Chad"],
  ["CL", "Chile"],
  ["CN", "China"],
  ["CX", "Christmas Island"],
  ["CO", "Colombia"],
  ["KM", "Comoros"],
  ["CG", "Congo (Brazzaville)"],
  ["CD", "Congo (Kinshasa)"],
  ["CK", "Cook Islands"],
  ["CR", "Costa Rica"],
  ["CI", "Côte D'ivoire"],
  ["HR", "Croatia"],
  ["CU", "Cuba"],
  ["CW", "Curaçao"],
  ["CY", "Cyprus"],
  ["CZ", "Czechia"],
  ["DK", "Denmark"],
  ["DJ", "Djibouti"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["EC", "Ecuador"],
  ["EG", "Egypt"],
  ["SV", "El Salvador"],
  ["GQ", "Equatorial Guinea"],
  ["ER", "Eritrea"],
  ["EE", "Estonia"],
  ["ET", "Ethiopia"],
  ["FK", "Falkland Islands (Islas Malvinas)"],
  ["FO", "Faroe Islands"],
  ["FJ", "Fiji"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GF", "French Guiana"],
  ["PF", "French Polynesia"],
  ["GA", "Gabon"],
  ["GM", "Gambia, The"],
  ["GE", "Georgia"],
  ["DE", "Germany"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GR", "Greece"],
  ["GL", "Greenland"],
  ["GD", "Grenada"],
  ["GP", "Guadeloupe"],
  ["GU", "Guam"],
  ["GT", "Guatemala"],
  ["GG", "Guernsey"],
  ["GN", "Guinea"],
  ["GW", "Guinea-Bissau"],
  ["GY", "Guyana"],
  ["HT", "Haiti"],
  ["HN", "Honduras"],
  ["HK", "Hong Kong"],
  ["HU", "Hungary"],
  ["IS", "Iceland"],
  ["IN", "India"],
  ["ID", "Indonesia"],
  ["IR", "Iran"],
  ["IQ", "Iraq"],
  ["IE", "Ireland"],
  ["IM", "Isle Of Man"],
  ["IL", "Israel"],
  ["IT", "Italy"],
  ["JM", "Jamaica"],
  ["JP", "Japan"],
  ["JE", "Jersey"],
  ["JO", "Jordan"],
  ["KZ", "Kazakhstan"],
  ["KE", "Kenya"],
  ["KI", "Kiribati"],
  ["KP", "Korea, North"],
  ["KR", "Korea, South"],
  ["XK", "Kosovo"],
  ["KW", "Kuwait"],
  ["KG", "Kyrgyzstan"],
  ["LA", "Laos"],
  ["LV", "Latvia"],
  ["LB", "Lebanon"],
  ["LS", "Lesotho"],
  ["LR", "Liberia"],
  ["LY", "Libya"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["MO", "Macau"],
  ["MK", "Macedonia"],
  ["MG", "Madagascar"],
  ["MW", "Malawi"],
  ["MY", "Malaysia"],
  ["MV", "Maldives"],
  ["ML", "Mali"],
  ["MT", "Malta"],
  ["MH", "Marshall Islands"],
  ["MQ", "Martinique"],
  ["MR", "Mauritania"],
  ["MU", "Mauritius"],
  ["YT", "Mayotte"],
  ["MX", "Mexico"],
  ["FM", "Micronesia, Federated States Of"],
  ["MD", "Moldova"],
  ["MC", "Monaco"],
  ["MN", "Mongolia"],
  ["ME", "Montenegro"],
  ["MS", "Montserrat"],
  ["MA", "Morocco"],
  ["MZ", "Mozambique"],
  ["MM", "Myanmar (Burma)"],
  ["NA", "Namibia"],
  ["NR", "Nauru"],
  ["NP", "Nepal"],
  ["NL", "Netherlands"],
  ["NC", "New Caledonia"],
  ["NZ", "New Zealand"],
  ["NI", "Nicaragua"],
  ["NE", "Niger"],
  ["NG", "Nigeria"],
  ["NU", "Niue"],
  ["NF", "Norfolk Island"],
  ["MP", "Northern Mariana Islands"],
  ["NO", "Norway"],
  ["OM", "Oman"],
  ["PK", "Pakistan"],
  ["PW", "Palau"],
  ["PA", "Panama"],
  ["PG", "Papua New Guinea"],
  ["PY", "Paraguay"],
  ["PE", "Peru"],
  ["PH", "Philippines"],
  ["PN", "Pitcairn Islands"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["PR", "Puerto Rico"],
  ["QA", "Qatar"],
  ["RE", "Reunion"],
  ["RO", "Romania"],
  ["RU", "Russia"],
  ["RW", "Rwanda"],
  ["BL", "Saint Barthelemy"],
  ["KN", "Saint Kitts And Nevis"],
  ["LC", "Saint Lucia"],
  ["MF", "Saint Martin"],
  ["PM", "Saint Pierre And Miquelon"],
  ["VC", "Saint Vincent And The Grenadines"],
  ["WS", "Samoa"],
  ["SM", "San Marino"],
  ["ST", "Sao Tome And Principe"],
  ["SA", "Saudi Arabia"],
  ["SN", "Senegal"],
  ["RS", "Serbia"],
  ["SC", "Seychelles"],
  ["SL", "Sierra Leone"],
  ["SG", "Singapore"],
  ["SX", "Sint Maarten"],
  ["SK", "Slovakia"],
  ["SI", "Slovenia"],
  ["SB", "Solomon Islands"],
  ["SO", "Somalia"],
  ["ZA", "South Africa"],
  ["SS", "South Sudan"],
  ["ES", "Spain"],
  ["LK", "Sri Lanka"],
  ["SD", "Sudan"],
  ["SR", "Suriname"],
  ["SZ", "Swaziland (Eswatini)"],
  ["SE", "Sweden"],
  ["CH", "Switzerland"],
  ["SY", "Syria"],
  ["TW", "Taiwan"],
  ["TJ", "Tajikistan"],
  ["TZ", "Tanzania"],
  ["TH", "Thailand"],
  ["TL", "Timor-Leste"],
  ["TG", "Togo"],
  ["TK", "Tokelau"],
  ["TO", "Tonga"],
  ["TT", "Trinidad And Tobago"],
  ["TN", "Tunisia"],
  ["TR", "Turkey"],
  ["TM", "Turkmenistan"],
  ["TC", "Turks And Caicos Islands"],
  ["TV", "Tuvalu"],
  ["VI", "U.S. Virgin Islands"],
  ["UG", "Uganda"],
  ["UA", "Ukraine"],
  ["AE", "United Arab Emirates"],
  ["GB", "United Kingdom"],
  ["US", "United States"],
  ["UY", "Uruguay"],
  ["UZ", "Uzbekistan"],
  ["VU", "Vanuatu"],
  ["VE", "Venezuela"],
  ["VN", "Vietnam"],
  ["VG", "Virgin Islands, British"],
  ["WF", "Wallis And Futuna"],
  ["EH", "Western Sahara"],
  ["YE", "Yemen"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
];

export const STATES = [
  // United States
  ["US-AL", "Alabama"], ["US-AK", "Alaska"], ["US-AZ", "Arizona"], ["US-AR", "Arkansas"],
  ["US-CA", "California"], ["US-CO", "Colorado"], ["US-CT", "Connecticut"], ["US-DE", "Delaware"],
  ["US-FL", "Florida"], ["US-GA", "Georgia"], ["US-HI", "Hawaii"], ["US-ID", "Idaho"],
  ["US-IL", "Illinois"], ["US-IN", "Indiana"], ["US-IA", "Iowa"], ["US-KS", "Kansas"],
  ["US-KY", "Kentucky"], ["US-LA", "Louisiana"], ["US-ME", "Maine"], ["US-MD", "Maryland"],
  ["US-MA", "Massachusetts"], ["US-MI", "Michigan"], ["US-MN", "Minnesota"], ["US-MS", "Mississippi"],
  ["US-MO", "Missouri"], ["US-MT", "Montana"], ["US-NE", "Nebraska"], ["US-NV", "Nevada"],
  ["US-NH", "New Hampshire"], ["US-NJ", "New Jersey"], ["US-NM", "New Mexico"], ["US-NY", "New York"],
  ["US-NC", "North Carolina"], ["US-ND", "North Dakota"], ["US-OH", "Ohio"], ["US-OK", "Oklahoma"],
  ["US-OR", "Oregon"], ["US-PA", "Pennsylvania"], ["US-RI", "Rhode Island"], ["US-SC", "South Carolina"],
  ["US-SD", "South Dakota"], ["US-TN", "Tennessee"], ["US-TX", "Texas"], ["US-UT", "Utah"],
  ["US-VT", "Vermont"], ["US-VA", "Virginia"], ["US-WA", "Washington"], ["US-WV", "West Virginia"],
  ["US-WI", "Wisconsin"], ["US-WY", "Wyoming"], ["US-DC", "District Of Columbia"],
  // Canada
  ["CA-AB", "Alberta"], ["CA-BC", "British Columbia"], ["CA-MB", "Manitoba"], ["CA-NB", "New Brunswick"],
  ["CA-NL", "Newfoundland And Labrador"], ["CA-NS", "Nova Scotia"], ["CA-NT", "Northwest Territories"],
  ["CA-NU", "Nunavut"], ["CA-ON", "Ontario"], ["CA-PE", "Prince Edward Island"], ["CA-QC", "Quebec"],
  ["CA-SK", "Saskatchewan"], ["CA-YT", "Yukon"],
  // Australia
  ["AU-NSW", "New South Wales"], ["AU-VIC", "Victoria"], ["AU-QLD", "Queensland"],
  ["AU-WA", "Western Australia"], ["AU-SA", "South Australia"], ["AU-TAS", "Tasmania"],
  ["AU-ACT", "Australian Capital Territory"], ["AU-NT", "Northern Territory"],
];

export const METROS = [
  ["jambase:195", "Abilene Area"], ["jambase:116", "Albany Area"], ["jambase:27", "Albany Area"],
  ["jambase:63", "Albuquerque - Santa Fe Area"], ["jambase:199", "Alexandria Area"],
  ["jambase:209", "Alpena Area"], ["jambase:167", "Amarillo Area"], ["jambase:138", "Anchorage Area"],
  ["jambase:40", "Asheville - Greenville SC Area"], ["jambase:10", "Atlanta Area"],
  ["jambase:149", "Auburn - Columbus Area"], ["jambase:130", "Augusta Area"], ["jambase:21", "Austin Area"],
  ["jambase:154", "Bakersfield Area"], ["jambase:35", "Baltimore Area"], ["jambase:101", "Bangor Area"],
  ["jambase:120", "Baton Rouge Area"], ["jambase:180", "Beaumont Area"], ["jambase:113", "Bend Area"],
  ["jambase:155", "Billings Area"], ["jambase:162", "Biloxi Area"], ["jambase:110", "Binghamton Area"],
  ["jambase:41", "Birmingham Area"], ["jambase:174", "Bluefield - Beckley - Oak Hill Area"],
  ["jambase:81", "Boise Area"], ["jambase:7", "Boston Area"], ["jambase:161", "Bowling Green Area"],
  ["jambase:39", "Buffalo Area"], ["jambase:49", "Burlington Area"], ["jambase:107", "Butte - Bozeman Area"],
  ["jambase:193", "Casper Area"], ["jambase:77", "Champaign-Urbana - Springfield Area"],
  ["jambase:105", "Charleston - Huntington Area"], ["jambase:62", "Charleston Area"],
  ["jambase:14", "Charlotte Area"], ["jambase:85", "Charlottesville Area"], ["jambase:69", "Chattanooga Area"],
  ["jambase:182", "Cheyenne Area"], ["jambase:2", "Chicago Area"], ["jambase:122", "Chico - Redding Area"],
  ["jambase:33", "Cincinnati Area"], ["jambase:159", "Clarksburg - Weston Area"], ["jambase:32", "Cleveland Area"],
  ["jambase:80", "Colorado Springs Area"], ["jambase:91", "Columbia Area"], ["jambase:133", "Columbia Area"],
  ["jambase:24", "Columbus Area"], ["jambase:164", "Corpus Christi Area"], ["jambase:11", "Dallas - Ft. Worth Area"],
  ["jambase:72", "Dayton Area"], ["jambase:8", "Denver Area"], ["jambase:67", "Des Moines Area"],
  ["jambase:15", "Detroit Area"], ["jambase:178", "Dothan Area"], ["jambase:142", "Duluth Area"],
  ["jambase:144", "El Paso Area"], ["jambase:147", "Elmira Area"], ["jambase:135", "Erie Area"],
  ["jambase:74", "Eugene Area"], ["jambase:129", "Eureka Area"], ["jambase:119", "Evansville Area"],
  ["jambase:205", "Fairbanks Area"], ["jambase:121", "Fargo - Valley City Area"], ["jambase:98", "Fayetteville Area"],
  ["jambase:106", "Flint - Saginaw - Bay City Area"], ["jambase:95", "Florence - Myrtle Beach Area"],
  ["jambase:87", "Fresno - Visalia Area"], ["jambase:79", "Ft. Myers - Naples Area"], ["jambase:117", "Ft. Wayne Area"],
  ["jambase:148", "Gainesville Area"], ["jambase:210", "Glendive Area"], ["jambase:134", "Grand Junction Area"],
  ["jambase:47", "Grand Rapids - Kalamazoo Area"], ["jambase:192", "Great Falls Area"],
  ["jambase:73", "Green Bay - Appleton Area"], ["jambase:59", "Greensboro - Winston-Salem Area"],
  ["jambase:82", "Greenville Area"], ["jambase:200", "Greenwood Area"], ["jambase:42", "Hampton Roads Area"],
  ["jambase:54", "Harrisburg - Lancaster Area"], ["jambase:152", "Harrisonburg Area"],
  ["jambase:18", "Hartford - New Haven Area"], ["jambase:132", "Hattiesburg Area"], ["jambase:186", "Helena Area"],
  ["jambase:71", "Honolulu Area"], ["jambase:30", "Houston Area"], ["jambase:84", "Huntsville Area"],
  ["jambase:140", "Idaho Falls - Jackson Hole Area"], ["jambase:29", "Indianapolis Area"],
  ["jambase:97", "Iowa City - Cedar Rapids Area"], ["jambase:165", "Jackson Area"], ["jambase:100", "Jackson Area"],
  ["jambase:55", "Jacksonville Area"], ["jambase:173", "Jonesboro Area"], ["jambase:176", "Joplin Area"],
  ["jambase:201", "Juneau Area"], ["jambase:38", "Kansas City Area"], ["jambase:58", "Knoxville Area"],
  ["jambase:112", "La Crosse - Eau Claire Area"], ["jambase:157", "Lafayette Area"], ["jambase:156", "Lafayette Area"],
  ["jambase:189", "Lake Charles Area"], ["jambase:111", "Lansing Area"], ["jambase:206", "Laredo Area"],
  ["jambase:202", "Las Vegas Area"], ["jambase:70", "Lexington Area"], ["jambase:191", "Lima Area"],
  ["jambase:118", "Lincoln Area"], ["jambase:88", "Little Rock Area"], ["jambase:3", "Los Angeles Area"],
  ["jambase:45", "Louisville Area"], ["jambase:175", "Lubbock Area"], ["jambase:137", "Macon Area"],
  ["jambase:50", "Madison Area"], ["jambase:183", "Mankato Area"], ["jambase:190", "Marquette Area"],
  ["jambase:163", "McAllen Area"], ["jambase:104", "Medford - Ashland Area"], ["jambase:44", "Memphis Area"],
  ["jambase:194", "Meridian Area"], ["jambase:34", "Miami - Ft. Lauderdale Area"], ["jambase:36", "Milwaukee Area"],
  ["jambase:13", "Minneapolis - St. Paul Area"], ["jambase:168", "Minot - Bismarck Area"], ["jambase:108", "Missoula Area"],
  ["jambase:76", "Mobile - Pensacola Area"], ["jambase:187", "Monroe - El Dorado Area"], ["jambase:150", "Montgomery Area"],
  ["jambase:9", "Nashville Area"], ["jambase:48", "New Orleans Area"], ["jambase:1", "New York City Area"],
  ["jambase:208", "North Platte Area"], ["jambase:68", "Northampton Area"], ["jambase:170", "Odessa - Midland Area"],
  ["jambase:65", "Oklahoma City Area"], ["jambase:51", "Omaha Area"], ["jambase:22", "Orlando Area"],
  ["jambase:198", "Ottumwa Area"], ["jambase:109", "Paducah - Cape Girardeau - Mount Vernon Area"],
  ["jambase:141", "Palm Springs Area"], ["jambase:158", "Panama City Area"], ["jambase:177", "Parkersburg Area"],
  ["jambase:139", "Pasco - Richland - Kennewick Area"], ["jambase:93", "Peoria - Bloomington Area"],
  ["jambase:5", "Philadelphia Area"], ["jambase:19", "Phoenix Area"], ["jambase:25", "Pittsburgh Area"],
  ["jambase:17", "Portland Area"], ["jambase:53", "Portland Area"], ["jambase:203", "Presque Isle Area"],
  ["jambase:31", "Providence Area"], ["jambase:102", "Quad Cities Area"], ["jambase:179", "Quincy - Hannibal Area"],
  ["jambase:26", "Raleigh-Durham Area"], ["jambase:166", "Rapid City Area"], ["jambase:78", "Reno - Tahoe Area"],
  ["jambase:52", "Richmond Area"], ["jambase:60", "Roanoke - Lynchburg Area"], ["jambase:145", "Rochester - Mason City Area"],
  ["jambase:43", "Rochester Area"], ["jambase:127", "Rockford Area"], ["jambase:23", "Sacramento Area"],
  ["jambase:114", "Salisbury Area"], ["jambase:37", "Salt Lake City Area"], ["jambase:196", "San Angelo Area"],
  ["jambase:61", "San Antonio Area"], ["jambase:20", "San Diego Area"], ["jambase:4", "San Francisco Bay Area"],
  ["jambase:83", "Santa Barbara - San Luis Obispo Area"], ["jambase:75", "Santa Cruz Area"],
  ["jambase:89", "Savannah Area"], ["jambase:12", "Seattle - Tacoma Area"], ["jambase:185", "Sherman - Ada Area"],
  ["jambase:151", "Shreveport Area"], ["jambase:172", "Sioux City Area"], ["jambase:128", "Sioux Falls Area"],
  ["jambase:90", "South Bend Area"], ["jambase:94", "Spokane Area"], ["jambase:86", "Springfield Area"],
  ["jambase:204", "St. Joseph Area"], ["jambase:16", "St. Louis Area"], ["jambase:92", "State College Area"],
  ["jambase:46", "Syracuse Area"], ["jambase:126", "Tallahassee Area"], ["jambase:28", "Tampa Bay Area"],
  ["jambase:171", "Terre Haute Area"], ["jambase:64", "Toledo Area"], ["jambase:146", "Topeka Area"],
  ["jambase:123", "Traverse City Area"], ["jambase:103", "Tri-Cities TN Area"], ["jambase:96", "Tucson Area"],
  ["jambase:66", "Tulsa Area"], ["jambase:169", "Tupelo Area"], ["jambase:181", "Twin Falls Area"],
  ["jambase:131", "Tyler - Longview Area"], ["jambase:124", "Utica Area"], ["jambase:207", "Victoria Area"],
  ["jambase:143", "Waco - College Station Area"], ["jambase:6", "Washington DC Area"], ["jambase:160", "Watertown Area"],
  ["jambase:136", "Wausau - Rhinelander Area"], ["jambase:56", "West Palm Beach - Boca Raton Area"],
  ["jambase:153", "Wheeling Area"], ["jambase:115", "Wichita - Salina Area"], ["jambase:184", "Wichita Falls - Lawton Area"],
  ["jambase:57", "Wilkes-Barre - Scranton Area"], ["jambase:99", "Wilmington Area"], ["jambase:125", "Youngstown Area"],
  ["jambase:188", "Yuma - El Centro Area"], ["jambase:197", "Zanesville Area"],
];
